import React from 'react';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
import { bonuses } from '../data/content';
export function BonusesSection() {
  return <section className="w-full bg-shell py-20 md:py-28" aria-labelledby="bonos" data-id="element-28" data-mp="vswcgasuh1ht">
      <div className="mx-auto max-w-6xl px-6 lg:px-8" data-id="element-29" data-mp="vqtb4um8rlxs">
        <SectionHeading eyebrow="Incluido hoy" title={<span id="bonos" data-id="element-31" data-mp="qvw6s0zwq0r8">Tres bonos para acompañarte en el camino</span>} data-id="element-30" data-mp="qsru0f8dlwoy" />

        <div className="mt-14 grid gap-7 md:grid-cols-3" data-id="element-32" data-mp="14rzxvlfhhszh">
          {bonuses.map((bonus, i) => <Reveal key={bonus.title} delay={i * 0.1} data-id="element-33" data-mp="ztpzz32dkea6" data-mpi={i}>
              <article className="flex h-full flex-col overflow-hidden rounded-[1.75rem] border border-sand bg-ivory transition-all duration-500 hover:-translate-y-1 hover:border-goldsoft hover:shadow-[0_30px_60px_-45px_rgba(58,51,46,0.5)]" data-id="element-34" data-mp="1ejdzbyqzx2v9">
                <img src={bonus.image} alt={`Vista previa del bono ${bonus.title}`} className="h-52 w-full object-cover" loading="lazy" data-id="element-35" data-mp="1nkvenewkx0iw" />
                <div className="flex flex-1 flex-col px-7 py-8" data-id="element-36" data-mp="1jgnnlb2nf8hi">
                  <div className="flex items-center justify-between" data-id="element-37" data-mp="3prn2rs4ncz05">
                    <span className="font-sans text-[0.6rem] uppercase tracking-luxe text-gold" data-id="element-38" data-mp="3tr5dxw6o1vps">
                      {bonus.label}
                    </span>
                    <span className="font-sans text-[0.68rem] uppercase tracking-[0.14em] text-mute" data-id="element-39" data-mp="2nyv41byhr84">
                      Valor {bonus.value}
                    </span>
                  </div>
                  <h3 className="mt-4 font-display text-2xl font-light leading-snug text-ink" data-id="element-40" data-mp="chpg2w8vjjj2">
                    {bonus.title}
                  </h3>
                  <span aria-hidden="true" className="mt-5 block h-[1px] w-10 bg-beige" data-id="element-41" data-mp="lbu4za4g6kvy" />
                  <p className="mt-5 font-sans text-[0.92rem] font-light leading-relaxed text-warmgray" data-id="element-42" data-mp="qbgfhbsw5n12">
                    {bonus.description}
                  </p>
                </div>
              </article>
            </Reveal>)}
        </div>
      </div>
    </section>;
}